// extracted by mini-css-extract-plugin
export default {"teaser":"PromoTeaser_teaser--l62"};